import React from 'react';

/**
 * TabNavigation - Horizontal tab navigation with smooth scrolling
 * @param {Array} tabs - Array of tab objects [{ id, label }]
 * @param {string} activeTab - Currently active tab id
 * @param {Function} onTabChange - Callback when tab is clicked
 */
const TabNavigation = ({ tabs, activeTab, onTabChange, pinned = true }) => {
  if (!tabs || tabs.length === 0) {
    return null;
  }

  return (
    <div className={`w-full border-b border-gray-200 bg-white shadow-sm ${pinned ? "sticky top-0 z-0" : "relative z-0"}`}>
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex space-x-8 overflow-x-auto" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors
                ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
              aria-current={activeTab === tab.id ? 'page' : undefined}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;
